import styled from '../../utils/styled';
import { mediaBreakpointDownMD } from '../../../constants/style-constants';

const selectColor = (item, active, sitePrimaryColor) => {
  if (sitePrimaryColor && item?.textColor === 'primary') {
    return sitePrimaryColor;
  }
  if (active && item?.activeTextColor) {
    return item?.activeTextColor;
  }
  if (item?.textColor) {
    return item?.textColor;
  }

  return '#fff';
};

const selectHoverColor = (item, sitePrimaryColor) => {
  if (sitePrimaryColor && item?.textColor === 'primary') {
    return sitePrimaryColor;
  }
  if (item?.hoverTextColor) {
    return item?.hoverTextColor;
  }

  return '#fff';
};

const selectBackground = (item, alternate) => {
  if (alternate) return '#ffffff';

  return item?.backgroundColor ? item.backgroundColor : '#101010';
};

const selectHoverBackgroundColor = (item, alternate) => {
  if (alternate) return selectBackground(item, alternate);
  return item?.hoverBackgroundColor ? item.hoverBackgroundColor : '#383838';
};

export const NavigationMenuItem = styled.a(
  {
    borderTop: '1px solid #343434',
    display: 'flex',
    fontSize: '25px',
  },
  ({
    item, active, sitePrimaryColor, alternate,
  }) => ({
    backgroundColor: selectBackground(item, alternate),
    color: selectColor(item, active, sitePrimaryColor),

    [mediaBreakpointDownMD]: {
      borderTop: 'none',
      borderBottom: alternate ? '1px solid #f6f6f6' : '1px solid #000000',
      borderLeft: active ? '1px solid #fff' : 'none',
    },
    '&:hover': {
      backgroundColor: selectHoverBackgroundColor(item, alternate),
      color: selectHoverColor(item, sitePrimaryColor),
    },
  }),
);

export const MenuList = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flex: '1',

  [mediaBreakpointDownMD]: {
    margin: '0px',
    marginBottom: '200px',
  },
});

export const MenuChildren = styled.div({
  flexDirection: 'column',
  padding: '0px',
});
